import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Preloader from '../components/Preloader';
import Sidebar from '../components/Sidebar';
import Header from '../components/Header';
import Footer from '../components/Footer';

const NotFound = () => {
  useEffect(() => {
    // Initialize scripts if needed
    if (window.initPathioScripts) {
      window.initPathioScripts();
    }
  }, []);

  return (
    <>
      <Preloader />
      <Sidebar />
      <Header />

      <main>

      <section className="ul-breadcrumb ul-section-spacing">
        <div className="ul-container">
          <h2 className="ul-breadcrumb-title">Error</h2>
          <ul className="ul-breadcrumb-nav">
            <li><Link to="/">Home</Link></li>
            <li>
              <span className="separator"><i className="flaticon-right"></i></span>
            </li>
            <li>Error</li>
          </ul>
        </div>
      </section>

      <section className="ul-404 ul-section-spacing text-center">
        <div className="ul-404-container">
          <div className="ul-404-img">
            <img
              src="/assets/new-img/new/happy-children-looking-at-camera-in-play-center-2025-03-08-20-07-35-utc.jpg"
              alt="Image"
            />
          </div>
          <h2 className="ul-section-title">
            Oops! Somethings Went Wrong Please Try Again Later
          </h2>
          <p>Sorry about that, but the page you looking is not available now</p>
          <Link to="/" className="ul-btn"
            ><i className="flaticon-fast-forward-double-right-arrows-symbol"></i>
            Back to Home</Link
          >
        </div>
      </section>
    </main>

      <Footer />
    </>
  );
};

export default NotFound;
